import { MissionKindEnum } from '@e-socna/data-layer';
import { buildPath } from '@e-socna/utils';

import {
  PATH_FOLDER_MISSIONS,
  PATH_MISSION_SUB_MISSIONS,
} from '../../../app/constants/paths.constant';
import { buildMissionPath } from '../../../app/utils/mission-space.util';
import { missionKindProfileOf } from '../../../app/utils/mission-kind-profile.util';

import type { MissionForm_Mission } from '../fragments/mission.fragment';

// Created from its collaboration, a sub-mission goes back to its sub-missions.
export const creationRedirectPathOf = ({
  compositeMissionId,
  folderId,
  kind,
}: Readonly<
  Pick<MissionForm_Mission, 'compositeMissionId' | 'folderId' | 'kind'>
>): string =>
  missionKindProfileOf(kind).isWithinACollaboration && compositeMissionId
    ? buildMissionPath(PATH_MISSION_SUB_MISSIONS, {
        folderId,
        missionId: compositeMissionId,
        kind: MissionKindEnum.Composite,
      })
    : buildPath(PATH_FOLDER_MISSIONS, { folderId });
